import { Navigate, Outlet } from 'react-router-dom';
import { BLAUTHTOKEN, getDataFromStore } from '../../utils/CookiesUtils';

const GuestWrapper = () => {
  const isAuthenticated = getDataFromStore(BLAUTHTOKEN) !== null;
  
  return isAuthenticated ? <Navigate to="/" replace /> : <Outlet />;
};

export default GuestWrapper;